export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity[ErrorSeverity["Error"] = 0] = "Error";
    ErrorSeverity[ErrorSeverity["LogError"] = 1] = "LogError";
    ErrorSeverity[ErrorSeverity["LogWarning"] = 2] = "LogWarning";
})(ErrorSeverity || (ErrorSeverity = {}));
//# sourceMappingURL=error-severity.js.map